<template>
  <div class="pb-5">
    <mz-page-image></mz-page-image>
    <div class="row">
      <div class="col">
        <mz-specs class="mt-3"></mz-specs>
        <div class="row my-3">
          <div class="col">
            <router-link to="/raw-data" class="btn btn-primary btn-block btn-lg">
              <fa-icon icon="heartbeat" /> Raw Data</router-link>
          </div>
          <div class="col">
            <router-link to="/health-report" class="btn btn-primary btn-block btn-lg">
              <fa-icon icon="stethoscope" /> Health Report</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageImage from '@/components/layout/PageImage'
import Specs from '@/components/views/home/Specs'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'home',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['specs'])
  },
  methods: {
    ...mapMutations(['setPageTitle'])
  },
  components: {
    mzPageImage: PageImage,
    mzSpecs: Specs
  },
  created () {
    this.setPageTitle({ title: this.specs.serialNumber, icon: null })
  }
}
</script>

<style lang="scss">
</style>




// WEBPACK FOOTER //
// src/components/views/home/Home.vue